<template>
  <div class="ll-btn-groups">
    <WsRow is-center :style="{ width: isFull ? '100%' : 'auto' }">
      <WsCol v-for="(btn, btnIndex) in btnList" :key="btnIndex" :cols="twoItem ? 6 : 4" smcols="12">
        <LlBtnGroupsItem
          :value="value"
          :btn="btn"
          :small-size="btnSmallSize"
          :normal-size="normalSize"
          @input="btnClick($event)"
        />
      </WsCol>
    </WsRow>
    <WsRow :style="{ width: '100%' }">
      <WsCol cols="12">
        <WsInputTextareaButton001
          v-if="_textareaCondition"
          :style="{ width: '100%' }"
          :value="textareaContent"
          :title="textareaTitle"
          class="mt-20"
          :placeholder="textareaPlaceHolder"
          :min-height="134"
          :max-height="300"
          :rules="textareaRules"
          :required="textareaRules === 'required'"
          @input="$_changeValue($event)"
        />
        <LvUploadFileList
          v-if="_uploadfileCondition"
          :value="uploadAttaches"
          upload
          multiple
          showDeleteBtn
          :uploadModule="uploadModule"
          class="mt-20 ml-0"
          @go-to="$_onGoToFile($event)"
          @input="$emit('update-attach', $event)"
        />
        <LvStateDropdownRadioInputAvatar001
          v-if="_isAvatarDropdown"
          :value="avatarDropdown.value"
          outline
          required
          avatarSelect
          rules="required"
          leadingIcon="icon-outline-perm-identity"
          :title="avatarDropdown.title"
          :selectValue="avatarDropdown.selectValue"
          :placeholder="avatarDropdown.placeholder ? avatarDropdown.placeholder : '選擇'"
          class="mt-10"
          @get-select-item="$_onInput($event, 'avatar')"
        />
      </WsCol>
    </WsRow>
  </div>
</template>
<script>
import H_file from '@/helpers/file';

export default {
  name: 'LlBtnGroups',
  props: {
    normalSize: {
      type: Boolean,
      default: false,
    },
    twoItem: {
      type: Boolean,
      default: false,
    },
    textareaRules: {
      type: String,
      default: '',
    },
    attachesRules: {
      type: String,
      default: '',
    },
    textareaDefaultShow: {
      type: Boolean,
      default: false,
    },
    attachesDefaultShow: {
      type: Boolean,
      default: false,
    },
    isFull: {
      type: Boolean,
      default: false,
    },
    fileBtnTitle: {
      type: String,
      default() {
        return this.$t('附件');
      },
    },
    btnSmallSize: {
      type: Boolean,
      default: false,
    },
    uploadAttaches: {
      type: Array,
      default() {
        return [];
      },
    },
    textareaTitle: {
      type: String,
      default: '',
    },
    textareaPlaceHolder: {
      type: String,
      default() {
        return this.$t('輸入');
      },
    },
    textareaCondition: {
      type: Boolean,
      default: false,
    },
    textareaContent: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Array, Number],
      default: null,
    },
    isToggle: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'mandatory',
    },
    btnList: {
      type: Array,
      default() {
        return [
          {
            score: 25,
            value: 'good',
            textLabel: '合規',
          },
          {
            value: 'notGood',
            textLabel: '不合規',
            subList: [
              {
                score: 23,
                value: 'Major',
                textLabel: 'Major(主要缺失)',
              },
              {
                score: 22,
                value: 'Minor',
                textLabel: 'Minor(次要缺失)',
              },
              {
                score: 21,
                value: 'OFI',
                textLabel: 'OFI(待改善)',
              },
            ],
          },
          {
            score: 20,
            value: 'nor',
            textLabel: '不適用',
          },
        ];
      },
    },
    avatarDropdown: {
      type: Object,
    },
    uploadModule: {
      type: String,
    },
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _textareaCondition() {
      if (this.textareaDefaultShow) return true;
      if (!this.value) return false;
      let btnIng = this.btnList.find(item => item.score === this.value);
      if (!btnIng) return false;
      return btnIng.textareaShow;
    },
    _uploadfileCondition() {
      if (this.attachesDefaultShow) return true;
      if (!this.value) return false;
      let btnIng = this.btnList.find(item => item.score === this.value);
      if (!btnIng) return false;
      return btnIng.uploadfileShow;
    },
    _isAvatarDropdown() {
      const btnIng = this.btnList.find(item => item.score === this.value);
      return btnIng && btnIng.avatarDropdown ? btnIng.avatarDropdown : false;
    },
  },
  methods: {
    btnClick(score) {
      this.$_resetTextArea(score);
      this.$emit('input', score);
    },
    $_resetTextArea(score) {
      this.$emit('reset-textarea', score);
    },
    $_changeValue(e) {
      this.$emit('change-textarea-vlue', e);
    },
    $_onInput($event, type) {
      if (type === 'avatar') this.$emit('click-avatar', $event);
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/ll-btn-groups';
</style>
